module.exports = __webpack_public_path__ + "static/media/no-purchased-course-icon.539a6c7c.svg";